<template>
  <Layout>
    <template #content>
      <div class="mainContent egameContent">
        <pageHead device="desktop" page="egame" :title="Title" :description="$t('store.egame_description')"/>
        <div class="pageTitle"></div>
        <gameMenu :categoryId="CategoryId"/>
        <eGame :categoryId="CategoryId" :title="Title"/>
      </div>
    </template>
  </Layout>
</template>
<script>
  const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
  import pageHead from "~/components/common/pageHead.vue";
  import gameMenu from "~/components/desktop/gameMenu.vue";
  import eGame from "~/pages/game/egame/egame.vue";
  export default {
    components: {
      Layout,
      pageHead,
      gameMenu,
      eGame,
    },
    data() {
      return {
        CategoryId: 3
      };
    },
    computed: {
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        let ProductData = this.Product(this.CategoryId).find((element) => parseInt(element.Id) === parseInt(this.ProductId));
        let ProductId   = ProductData ? ProductData.Id : this.Product(this.CategoryId)[0].Id;
        let ProductName = ProductData ? ProductData.GameName : this.Product(this.CategoryId)[0].GameName;
        if (this.HasX)
          return ProductName + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
        else
          return this.$t("store.game_egame") + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
      },
      ...mapState(['WebSetting']),
      ...mapState("game", ["ProductId"]),
      ...mapGetters(["Product", "WebSeoName", "ShowPageWebSeoName"]),
    },
  };
</script>

<style scoped></style>
